module.exports = __webpack_public_path__ + "media/application/images/demo/main3-781f98c337421ac8b62bec3fc13af2b9.jpg";